<template>
    <!-- 寻物列表 -->
    <div id="treasureDiv" class="wrap">
        <el-dialog :visible.sync="treasureListVisible" 
        :before-close="treasure_list_dialog_close" v-loading="loading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
              <center><font color="ff0000" class="title">小道消息</font></center><hr color="000000">
              <div v-if="null != fantasyTreasureBOList" id="fantasyTreasureBOList">
                  <el-row>
                    <el-col :span="2"><span></span></el-col>
                    <el-col :span="10"><span>遗失物</span></el-col>
                    <el-col :span="6"><span>当前状态</span></el-col>
                    <el-col :span="6"><span>操作</span></el-col>
                  </el-row>
                  <div v-for="treasure in fantasyTreasureBOList" v-bind:key="treasure.id" :id="treasure.id + '_treasure'" class="treasureList">
                    <el-row>
                        <el-col :span="2">
						    <span v-if="treasure.itemStatus==0"></span>
                            <span v-else><img @click="showTitle(treasure.name)" :title="treasure.name" :src="ossPath + treasure.imgsrc"></span>
                            </el-col>
                        <el-col :span="10">
						    <span v-if="treasure.itemStatus==0">神秘物品</span>
                            <span v-else @click="showTitle(treasure.itemDesc)" :title="treasure.itemDesc">{{treasure.name}}</span>
                        </el-col>
                        <el-col :span="6">
                            <span v-if="treasure.itemStatus==0" style="color:#0080FF;">搜寻中</span>
                            <span v-else-if="treasure.itemStatus==1" style="color:red;">已找到</span>
                            <span v-else style="color:gray;">已完成</span>
                        </el-col>
                        <el-col :span="6">
                            <!-- 寻物雷达改造（2026-10-15）：接单即锁定，一件失物同一时刻只能被一个人打听走 -->
                            <span v-if="treasure.itemStatus==0 && !treasure.ownerId"><a @click="acceptTreasureTask(treasure.id);">打听一下</a></span>
                            <span v-else-if="treasure.itemStatus==0 && treasure.ownerId == myId" style="color:#0080FF;">你的委托</span>
                            <span v-else-if="treasure.itemStatus==0" style="color:#999;">已有人打听走了</span>
                            <span v-else></span>
                        </el-col>
                    </el-row>
                  </div>
              </div>
              <div class="noTreasureList" v-if="null == fantasyTreasureBOList">
                  未查询到寻物列表
              </div>
              <div style="clear:both"></div>




          </div>
        </el-dialog>
    </div>
</template>

<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'treasureList',
  props:{
    treasureListVisible: {
      type: Boolean,
      default: false
    },
    fantasyUserBO: Object,
  },
  data() {
    return {
        fantasyTreasureBOList: [],
        loading: false,
    };
  },
  computed: {
    // 当前玩家ID：用于区分"你的委托 / 已有人打听走了"
    myId() {
      return (this.fantasyUserBO && this.fantasyUserBO.id) || '';
    }
  },
  watch: {
    treasureListVisible: {
      handler(newVal) {
        if (newVal === true) {
          this.showTreasureList();
        }
      }
    }
  },
  mounted: function () {
      if (this.treasureListVisible) {
          this.showTreasureList();
      }
  },
  methods: {
    //寻物列表
    showTreasureList: function(){
      this.fantasyTreasureBOList = [];
      this.loading = true;
      //寻物列表，查询全部寻物信息
        getRequest('/item/treasure/getLostList', {
        }).then(resp=> {
            this.loading = false;
            if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                    if (null != respData.data) {
                    this.fantasyTreasureBOList = respData.data;
                    }
                } else {
                    Message.error(respData.message);
                }
            } else {
                //失败
                Message.error('查询全部寻物信息失败');
            }
        }, resp=> {
            Message.error('查询全部寻物信息异常');
        });
    },
    treasure_list_dialog_close() {
		this.$emit("treasure_list_dialog_close");
    },
    acceptTreasureTask: function(value) {
        var _this = this;
        postRequest('/item/treasure/acceptTreasureTask', {
            treasureId: value
        }).then(resp=> {
            if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                    this.treasure_list_dialog_close();
                    // 后端回传带截止口径的提示（D1：请在今日 24:00 前交给失主）
                    Message.success(respData.message || "您已成功申请寻物任务，快打开寻物雷达看看在哪吧。");
                } else {
					Message.error(respData.message);
                }
            } else {
                //失败
                Message.error('用户非法⊙﹏⊙∥!');
            }
        }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
        });
    },
    // 移动端点击后显示提示信息
    showTitle(value) {
        this.$notify({
            message: value,
            duration: 6000
        })
    },
  },
  beforeDestroy: function() {
  }
}
</script>

<style scoped>
a {
    cursor: pointer;
    color: blue;
}
.wrap {
    margin:auto;
    text-align: center;
}
.itembg {
    width:80%;
    height:100%;
    text-align: center;
    margin: 0 auto;
}
#fantasyTreasureBOList {
  /* 解决div内容显示超过div高度的问题 */
  height:100%;
  /* overflow-y:scroll; */
}
.title {
    font-size: 20px;
    line-height: 40px;
}
.treasureRow {
    background-color: #ffffee;
    text-align: left;
}
.treasureTitle {
    color:#fff;
    font-weight: bolder;
    margin: 5px 0;
}
.noTreasureList {
    padding:3px 5px;
    font-size:16px;
    font-weight:bold;
    letter-spacing:5px;
    text-align:center;
    height: 100px;
    line-height: 100px;
}
#fantasyTreasureBOList .el-row {
    font-size: 14px;
}
#fantasyTreasureBOList .el-col span {
    height: 40px;
    line-height: 40px;
}

.treasureList .el-col img {
    height: 40px;
    line-height: 40px;
}
</style>